import type { ExperimentsClient } from '@ingka-group-digital/window-ikea-typings/src/experimentum/exptSDK';

let experimentsClient: ExperimentsClient | undefined;

const initOptimizely = () => {
  if (experimentsClient) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }
  if (!OPTIMIZELY_SDK_KEY) {
    return;
  }

  const exptSDKInit = window.ikea?.exptSDK?.init;

  if (!exptSDKInit) {
    return;
  }

  exptSDKInit(OPTIMIZELY_SDK_KEY).then(({ client, error }) => {
    if (error) {
      return;
    }
    experimentsClient = client;
  });
};

export const sendEventToOptimizely = (eventName: string): void => {
  if (!experimentsClient) {
    initOptimizely();
  }
  experimentsClient?.track(eventName);
};
